var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableWrapper',[_c('TableLoading',{attrs:{"columns":_vm.tableColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }